import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import FormSection from 'components/sales/formSection/formSectionNew';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import 'react-toastify/dist/ReactToastify.css';
import DocumentView from "../../../components/sales/downloadDocView/documentView";
import ModalPop from 'components/sales/modal/modal';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import DatePicker from "components/sales/datePicker/datePicker";
import Images from 'assets/images/imageData';
import { Link } from "react-router-dom";

const InspectionForm = ({
    match,
    documentUploadUrlPublic,
    viewSiteInspectionForms,
    viewInspectionForm,
    viewInspectionForms,
    setInspectionForm
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const roleId = localStorage.getItem('fusion-role');
    const barriers = {
        model: "",
        model_origin: "",
        year_of_manufacture: "",
        date_of_purchase: "",
        spare_available: "",
        amc_scope: "",
        amc_scope_reason: "",
        lcm_ocm: "",
        recommend_lcm: "",
        foundation_status: "",
        foundation_required: "",
        motor_control_card_functionality: "",
        motor_control_card_required: "",
        arm_status: "",
        arm_required: "",
        safety_available: "",
        loop_photocell_required: "",
        any_abnormal_sound: "",
        abnormal_sound: "",
        file_path: []
    }
    const readers = {
        model: "",
        model_origin: "",
        year_of_manufacture: "",
        date_of_purchase: "",
        spare_available: "",
        amc_scope: "",
        amc_scope_reason: "",
        lcm_ocm: "",
        recommend_lcm: "",
        reader_available: "",
        reader_available_recommend: "",
        pcb_replacement_feasible: "",
        pcb_replacement_feasible_recommend: "",
        type_of_antenna: "",
        type_of_antenna_recommend: "",
        file_path: []
    }
    const tvms = {
        model: "",
        model_origin: "",
        year_of_manufacture: "",
        date_of_purchase: "",
        spare_available: "",
        amc_scope: "",
        amc_scope_reason: "",
        lcm_ocm: "",
        recommend_lcm: "",
        printer_integration: "",
        printer_integration_recommend: "",
        cabinate_condition: "",
        cabinate_condition_recommend: "",
        power_control_install: "",
        power_control_install_recommend: "",
        file_path: []
    }
    const leds = {
        model: "",
        model_origin: "",
        year_of_manufacture: "",
        date_of_purchase: "",
        spare_available: "",
        amc_scope: "",
        amc_scope_reason: "",
        lcm_ocm: "",
        recommend_lcm: "",
        feedback_recommend_tech_team: "",
        file_path: []
    }
    const anprs = {
        model: "",
        model_origin: "",
        year_of_manufacture: "",
        date_of_purchase: "",
        spare_available: "",
        amc_scope: "",
        amc_scope_reason: "",
        lcm_ocm: "",
        recommend_lcm: "",
        feedback_recommend_tech_team: "",
        file_path: []
    }
    const inputs = {
        request_id: 0,
        status: 3,
        barrier: [barriers],
        reader: [readers],
        tvm: [tvms],
        led: [leds],
        anpr: [anprs],
        remarks: ""
    };

    const [formData, setData] = useState(inputs);
    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await viewSiteInspectionForms(true);
            await viewInspectionForm(match.params.id);
            setIsLoading(false);
        })();
    }, []);

    useEffect(() => {
        if (viewInspectionForms !== null) {
            setData({ ...formData, barrier: viewInspectionForms?.barrier, reader: viewInspectionForms?.reader, tvm: viewInspectionForms?.tvm, led: viewInspectionForms?.led, anpr: viewInspectionForms?.anpr, remarks: viewInspectionForms?.remarks })
        }
    }, [viewInspectionForms])

    useEffect(() => {
        if (match.params.id !== undefined) {
            setData({ ...formData, request_id: match.params.id });
        }
    }, [match.params.id]);

    const headerBtns = () => {
        if (viewInspectionForms == null || viewInspectionForms.status == 2) {
            return (<>
                <Button onClick={() => handleSubmit(1)} className="btn btn-primary">
                    Save
                    <img src={Images?.ArrowRight} alt="" />
                </Button>
                <Button onClick={handleSubmit} className="btn btn-primary">
                    Submit Form
                    <img src={Images?.ArrowRight} alt="" />
                </Button></>
            );
        }
    };
    const mainHeaderBtns = () => {
        if (viewInspectionForms != null && viewInspectionForms.status == 3) {
            return (
                <>
                    <Button onClick={() => handleSubmit(1)} className="btn btn-primary">
                        Save
                        <img src={Images?.ArrowRight} alt="" />
                    </Button>
                    <Button onClick={handleSubmit} className="btn btn-primary">
                        Approve Form
                        <img src={Images?.ArrowRight} alt="" />
                    </Button>
                </>
            );
        }
    }
    const handleSubmit = (save = 0) => {
        if ((formData?.remarks == undefined || formData?.remarks == '')) {
            toast.error('Fill Remarks field!');
            return;
        } else {
            (async () => {
                setIsLoading(true);
                save = (save == 1 ? 1 : 0);
                const res = await setInspectionForm(formData, save);
                setIsLoading(false);
                if (res) {
                    setIsModal(true);
                } else {
                    toast.error('Some error occurred. Please try again later.');
                    return;
                }
            })();
        }
    };

    const add = (type) => {
        switch (type) {
            case 'barrier':
                var form = formData?.barrier;
                setData({ ...formData, barrier: [...form, barriers] })
                break;
            case 'reader':
                var form = formData?.reader;
                setData({ ...formData, reader: [...form, readers] })
                break;
            case 'tvm':
                var form = formData?.tvm;
                setData({ ...formData, tvm: [...form, tvms] })
                break;
            case 'led':
                var form = formData?.led;
                setData({ ...formData, led: [...form, leds] })
                break;
            case 'anpr':
                var form = formData?.anpr;
                setData({ ...formData, anpr: [...form, anprs] })
                break;
        }
    }



    const del = (type, ind) => {
        if (ind !== 0) {
            switch (type) {
                case 'barrier':
                    var list = formData?.barrier
                    var data = list.filter((_, i) => i !== ind)
                    setData({ ...formData, barrier: data })
                    break;
                case 'reader':
                    var list = formData?.reader
                    var data = list.filter((_, i) => i !== ind)
                    setData({ ...formData, reader: data })
                    break;
                case 'tvm':
                    var list = formData?.tvm
                    var data = list.filter((_, i) => i !== ind)
                    setData({ ...formData, tvm: data })
                    break;
                case 'led':
                    var list = formData?.led
                    var data = list.filter((_, i) => i !== ind)
                    setData({ ...formData, led: data })
                    break;
                case 'anpr':
                    var list = formData?.anpr
                    var data = list.filter((_, i) => i !== ind)
                    setData({ ...formData, anpr: data })
                    break;
            }
        }
    }

    return (
        <Layout
            title='Inpection Requests'
            Buttons={roleId == 9 && headerBtns || mainHeaderBtns}
            isGoback
            isLoading={isLoading}
        >
            <FormSection title='Hardware Checkpoints - '>
                {formData?.barrier.map((elem, ind) => {
                    return (
                        <div className="panel-card card-details">
                            <div className="panel-heading d-flex flex-row justify-content-between">
                                <div>Barrier {ind + 1}</div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                        className="bi bi-plus-circle mr-3" style={{ cursor: "pointer" }} viewBox="0 0 16 16" onClick={() => add("barrier")}>
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                        className="bi bi-dash-circle" style={{ cursor: "pointer" }} viewBox="0 0 16 16" onClick={() => del("barrier", ind)}>
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                                    </svg>
                                </div>
                            </div>
                            <div className="panel-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Make'
                                            value={elem?.model}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.barrier]
                                                data[ind] = { ...elem, model: value }
                                                setData({ ...formData, barrier: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Origin of Make'
                                            value={elem?.model_origin}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.barrier]
                                                data[ind] = { ...elem, model_origin: value }
                                                setData({ ...formData, barrier: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <DatePicker
                                            label='Year of Manufacturing'
                                            value={elem?.year_of_manufacture}
                                            handleChange={(value) => {
                                                const data = [...formData?.barrier]
                                                data[ind] = { ...elem, year_of_manufacture: value }
                                                setData({ ...formData, barrier: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <DatePicker
                                            label='Date of purchase as per PO'
                                            value={elem?.date_of_purchase}
                                            handleChange={(value) => {
                                                const data = [...formData?.barrier]
                                                data[ind] = { ...elem, date_of_purchase: value }
                                                setData({ ...formData, barrier: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <ConstantInput
                                            label='Spare Availability'
                                            value={elem?.spare_available}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.barrier]
                                                data[ind] = { ...elem, spare_available: value }
                                                setData({ ...formData, barrier: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <DropDownInput
                                            label='AMC Scope'
                                            data={[
                                                { id: 'Comprehensive', name: "Comprehensive" },
                                                { id: 'Non-Comprehensive', name: "Non-Comprehensive" },
                                                { id: 'No AMC Scope', name: "No AMC Scope" },
                                            ]}
                                            value={elem?.amc_scope}
                                            getIdValue={(val) => {
                                                const data = [...formData?.barrier]
                                                data[ind] = { ...elem, amc_scope: val.id }
                                                setData({ ...formData, barrier: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Reason for AMC Scope'
                                            value={elem?.amc_scope_reason}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.barrier]
                                                data[ind] = { ...elem, amc_scope_reason: value }
                                                setData({ ...formData, barrier: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Remaining life of hardware'
                                            value={elem?.lcm_ocm}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.barrier]
                                                data[ind] = { ...elem, lcm_ocm: value }
                                                setData({ ...formData, barrier: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Recommendation on Life Expectancy'
                                            value={elem?.recommend_lcm}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.barrier]
                                                data[ind] = { ...elem, recommend_lcm: value }
                                                setData({ ...formData, barrier: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <DropDownInput
                                            label='Foundation civil work status'
                                            data={[
                                                { id: 'Ok', name: "Ok" },
                                                { id: 'Not Ok', name: "Not Ok" }
                                            ]}
                                            value={elem?.foundation_status}
                                            getIdValue={(val) => {
                                                const data = [...formData?.barrier]
                                                data[ind] = { ...elem, foundation_status: val.id }
                                                setData({ ...formData, barrier: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <ConstantInput
                                            label='New foundation required ?'
                                            value={elem?.foundation_required}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.barrier]
                                                data[ind] = { ...elem, foundation_required: value }
                                                setData({ ...formData, barrier: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <DropDownInput
                                            label='Motor & control card functionality'
                                            data={[
                                                { id: 'Working', name: "Working" },
                                                { id: 'Not Working', name: "Not Working" },
                                                { id: 'Need to Repair', name: "Need to Repair" },
                                                { id: 'Need to Replace', name: "Need to Replace" }
                                            ]}
                                            value={elem?.motor_control_card_functionality}
                                            getIdValue={(val) => {
                                                const data = [...formData?.barrier]
                                                data[ind] = { ...elem, motor_control_card_functionality: val.id }
                                                setData({ ...formData, barrier: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <ConstantInput
                                            label='New motor / control card required? '
                                            value={elem?.motor_control_card_required}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.barrier]
                                                data[ind] = { ...elem, motor_control_card_required: value }
                                                setData({ ...formData, barrier: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <DropDownInput
                                            label='Boom Arm status'
                                            data={[
                                                { id: 'Ok', name: "Ok" },
                                                { id: 'Not Ok', name: "Not Ok" },
                                                { id: 'Need to Repair', name: "Need to Repair" },
                                                { id: 'Need to Replace', name: "Need to Replace" }
                                            ]}
                                            value={elem?.arm_status}
                                            getIdValue={(val) => {
                                                const data = [...formData?.barrier]
                                                data[ind] = { ...elem, arm_status: val.id }
                                                setData({ ...formData, barrier: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <ConstantInput
                                            label='New arm required?'
                                            value={elem?.arm_required}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.barrier]
                                                data[ind] = { ...elem, arm_required: value }
                                                setData({ ...formData, barrier: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <DropDownInput
                                            label='Safety available '
                                            data={[
                                                { id: 'Magnetic Loop', name: "Magnetic Loop" },
                                                { id: 'Photocell', name: "Photocell" },
                                                { id: 'No safety available', name: "No safety available" }
                                            ]}
                                            value={elem?.safety_available}
                                            getIdValue={(val) => {
                                                const data = [...formData?.barrier]
                                                data[ind] = { ...elem, safety_available: val.id }
                                                setData({ ...formData, barrier: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <ConstantInput
                                            label='New loop / photocell reuired?'
                                            value={elem?.loop_photocell_required}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.barrier]
                                                data[ind] = { ...elem, loop_photocell_required: value }
                                                setData({ ...formData, barrier: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <DropDownInput
                                            label='Any abnormal sound'
                                            data={[
                                                { id: 'Yes', name: "Yes" },
                                                { id: 'No', name: "No" }
                                            ]}
                                            value={elem?.any_abnormal_sound}
                                            getIdValue={(val) => {
                                                const data = [...formData?.barrier]
                                                data[ind] = { ...elem, any_abnormal_sound: val.id }
                                                setData({ ...formData, barrier: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <ConstantInput
                                            label='If NO specify reason of sound'
                                            value={elem?.abnormal_sound}
                                            errorMsg='Readers Make Required'
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.barrier]
                                                data[ind] = { ...elem, abnormal_sound: value }
                                                setData({ ...formData, barrier: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    {viewInspectionForms?.status != 4 &&
                                        <div className="col-md-6 col-sm-12">
                                            <FileUpload
                                                id={"barrier"}
                                                multiple
                                                accept=".pdf,.png,.jpg,.jpeg,.doc,.mp4,.xlsx,.xls"
                                                documentUploadUrl={documentUploadUrlPublic}
                                                onChange={(val) => {
                                                    const data = [...formData?.barrier]
                                                    data[ind] = { ...elem, file_path: val }
                                                    setData({ ...formData, barrier: data })
                                                }}
                                            >
                                                <span className="btn btn-transparent">
                                                    Attach Files
                                                </span>
                                            </FileUpload>
                                        </div>
                                    }
                                    {viewInspectionForms?.barrier?.file_path && viewInspectionForms?.barrier?.file_path.map((val) => {
                                        return (
                                            <>

                                                {val !== "" && val !== null && (
                                                    <div className="col-md-4">
                                                        <DocumentView
                                                            title={localization.attachment}
                                                            attachment={val}
                                                        />
                                                    </div>
                                                )}
                                            </>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    )
                })}

                {formData?.reader.map((elem, ind) => {
                    return (
                        <div className="panel-card card-details">
                            <div className="panel-heading d-flex flex-row justify-content-between">
                                <div>Reader {ind + 1}</div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                        className="bi bi-plus-circle mr-3" style={{ cursor: "pointer" }} viewBox="0 0 16 16" onClick={() => add("reader")}>
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                        className="bi bi-dash-circle" style={{ cursor: "pointer" }} viewBox="0 0 16 16" onClick={() => del("reader", ind)}>
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                                    </svg>
                                </div>
                            </div>
                            <div className="panel-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Make'
                                            value={elem?.model}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.reader]
                                                data[ind] = { ...elem, model: value }
                                                setData({ ...formData, reader: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Origin of Make'
                                            value={elem?.model_origin}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.reader]
                                                data[ind] = { ...elem, model_origin: value }
                                                setData({ ...formData, reader: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <DatePicker
                                            label='Year of Manufacturing'
                                            required={true}
                                            value={elem?.year_of_manufacture}
                                            handleChange={(value) => {
                                                const data = [...formData?.reader]
                                                data[ind] = { ...elem, year_of_manufacture: value }
                                                setData({ ...formData, reader: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <DatePicker
                                            label='Date of purchase as per PO'
                                            required={true}
                                            value={elem?.date_of_purchase}
                                            handleChange={(value) => {
                                                const data = [...formData?.reader]
                                                data[ind] = { ...elem, date_of_purchase: value }
                                                setData({ ...formData, reader: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <ConstantInput
                                            label='Spare Availability'
                                            value={elem?.spare_available}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.reader]
                                                data[ind] = { ...elem, spare_available: value }
                                                setData({ ...formData, reader: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <DropDownInput
                                            label='AMC Scope'
                                            data={[
                                                { id: 'Comprehensive', name: "Comprehensive" },
                                                { id: 'Non-Comprehensive', name: "Non-Comprehensive" },
                                                { id: 'No AMC Scope', name: "No AMC Scope" },
                                            ]}
                                            value={elem?.amc_scope}
                                            getIdValue={(val) => {
                                                const data = [...formData?.reader]
                                                data[ind] = { ...elem, amc_scope: val.id }
                                                setData({ ...formData, reader: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Reason for AMC Scope'
                                            value={elem?.amc_scope_reason}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.reader]
                                                data[ind] = { ...elem, amc_scope_reason: value }
                                                setData({ ...formData, reader: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Remaining life of hardware'
                                            value={elem?.lcm_ocm}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.reader]
                                                data[ind] = { ...elem, lcm_ocm: value }
                                                setData({ ...formData, reader: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Recommendation on Life Expectancy'
                                            value={elem?.recommend_lcm}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.reader]
                                                data[ind] = { ...elem, recommend_lcm: value }
                                                setData({ ...formData, reader: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <DropDownInput
                                            label='Type of reader available'
                                            data={[
                                                { id: 'Long Range', name: "Long Range" },
                                                { id: 'Short Range', name: "Short Range" }
                                            ]}
                                            value={elem?.reader_available}
                                            getIdValue={(val) => {
                                                const data = [...formData?.reader]
                                                data[ind] = { ...elem, reader_available: val.id }
                                                setData({ ...formData, reader: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <ConstantInput
                                            label='Recommendation'
                                            value={elem?.reader_available_recommend}
                                            errorMsg='Readers Make Required'
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.reader]
                                                data[ind] = { ...elem, reader_available_recommend: value }
                                                setData({ ...formData, reader: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <DropDownInput
                                            label='Is PCB replacement feasible?'
                                            data={[
                                                { id: 'Yes', name: "Yes" },
                                                { id: 'No', name: "No" }
                                            ]}
                                            value={elem?.pcb_replacement_feasible}
                                            getIdValue={(val) => {
                                                const data = [...formData?.reader]
                                                data[ind] = { ...elem, pcb_replacement_feasible: val.id }
                                                setData({ ...formData, reader: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <ConstantInput
                                            label='Recommendation'
                                            value={elem?.pcb_replacement_feasible_recommend}
                                            errorMsg='Readers Make Required'
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.reader]
                                                data[ind] = { ...elem, pcb_replacement_feasible_recommend: value }
                                                setData({ ...formData, reader: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <DropDownInput
                                            label='Type of antenna'
                                            data={[
                                                { id: 'Male', name: "Male" },
                                                { id: 'Female', name: "Female" }
                                            ]}
                                            value={elem?.type_of_antenna}
                                            getIdValue={(val) => {
                                                const data = [...formData?.reader]
                                                data[ind] = { ...elem, type_of_antenna: val.id }
                                                setData({ ...formData, reader: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <ConstantInput
                                            label='Recommendation'
                                            value={elem?.type_of_antenna_recommend}
                                            errorMsg='Readers Make Required'
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.reader]
                                                data[ind] = { ...elem, type_of_antenna_recommend: value }
                                                setData({ ...formData, reader: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    {viewInspectionForms?.status != 4 &&
                                        <div className="col-md-6 col-sm-12">
                                            <FileUpload
                                                id={"reader"}
                                                multiple
                                                accept=".pdf,.png,.jpg,.jpeg,.doc,.mp4,.xlsx,.xls"
                                                documentUploadUrl={documentUploadUrlPublic}
                                                onChange={(val) => {
                                                    const data = [...formData?.reader]
                                                    data[ind] = { ...elem, file_path: val }
                                                    setData({ ...formData, reader: data })
                                                }}
                                            >
                                                <span className="btn btn-transparent">
                                                    Attach Files
                                                </span>
                                            </FileUpload>

                                        </div>}
                                    {viewInspectionForms?.reader?.file_path && viewInspectionForms?.reader?.file_path.map((val) => {
                                        return (
                                            <>

                                                {val !== "" && val !== null && (
                                                    <div className="col-md-4">
                                                        <DocumentView
                                                            title={localization.attachment}
                                                            attachment={val}
                                                        />
                                                    </div>
                                                )}
                                            </>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    )
                })}

                {formData?.tvm.map((elem, ind) => {
                    return (
                        <div className="panel-card card-details">
                            <div className="panel-heading d-flex flex-row justify-content-between">
                                <div>TVM {ind + 1}</div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                        className="bi bi-plus-circle mr-3" style={{ cursor: "pointer" }} viewBox="0 0 16 16" onClick={() => add("tvm")}>
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                        className="bi bi-dash-circle" style={{ cursor: "pointer" }} viewBox="0 0 16 16" onClick={() => del("tvm", ind)}>
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                                    </svg>
                                </div>
                            </div>
                            <div className="panel-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Make'
                                            value={elem?.model}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.tvm]
                                                data[ind] = { ...elem, model: value }
                                                setData({ ...formData, tvm: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Origin of Make'
                                            value={elem?.model_origin}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.tvm]
                                                data[ind] = { ...elem, model_origin: value }
                                                setData({ ...formData, tvm: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <DatePicker
                                            label='Year of Manufacturing'
                                            required={true}
                                            value={elem?.year_of_manufacture}
                                            handleChange={(value) => {
                                                const data = [...formData?.tvm]
                                                data[ind] = { ...elem, year_of_manufacture: value }
                                                setData({ ...formData, tvm: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <DatePicker
                                            label='Date of purchase as per PO'
                                            required={true}
                                            value={elem?.date_of_purchase}
                                            handleChange={(value) => {
                                                const data = [...formData?.tvm]
                                                data[ind] = { ...elem, date_of_purchase: value }
                                                setData({ ...formData, tvm: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <ConstantInput
                                            label='Spare Availability'
                                            value={elem?.spare_available}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.tvm]
                                                data[ind] = { ...elem, spare_available: value }
                                                setData({ ...formData, tvm: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <DropDownInput
                                            label='AMC Scope'
                                            data={[
                                                { id: 'Comprehensive', name: "Comprehensive" },
                                                { id: 'Non-Comprehensive', name: "Non-Comprehensive" },
                                                { id: 'No AMC Scope', name: "No AMC Scope" },
                                            ]}
                                            value={elem?.amc_scope}
                                            getIdValue={(val) => {
                                                const data = [...formData?.tvm]
                                                data[ind] = { ...elem, amc_scope: val.id }
                                                setData({ ...formData, tvm: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Reason for AMC Scope'
                                            value={elem?.amc_scope_reason}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.tvm]
                                                data[ind] = { ...elem, amc_scope_reason: value }
                                                setData({ ...formData, tvm: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Remaining life of hardware'
                                            value={elem?.lcm_ocm}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.tvm]
                                                data[ind] = { ...elem, lcm_ocm: value }
                                                setData({ ...formData, tvm: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Recommendation on Life Expectancy'
                                            value={elem?.recommend_lcm}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.tvm]
                                                data[ind] = { ...elem, recommend_lcm: value }
                                                setData({ ...formData, tvm: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <DropDownInput
                                            label='Existing printer integration feasible?'
                                            data={[
                                                { id: 'Yes', name: "Yes" },
                                                { id: 'No', name: "No" }
                                            ]}
                                            value={elem?.printer_integration}
                                            getIdValue={(val) => {
                                                const data = [...formData?.tvm]
                                                data[ind] = { ...elem, file_path: val.id }
                                                setData({ ...formData, tvm: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <ConstantInput
                                            label='Recommendation'
                                            value={elem?.printer_integration_recommend}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.tvm]
                                                data[ind] = { ...elem, printer_integration_recommend: value }
                                                setData({ ...formData, tvm: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <DropDownInput
                                            label='Physical condition of existing cabinet'
                                            data={[
                                                { id: 'Ok', name: "Ok" },
                                                { id: 'Not Ok', name: "Not Ok" }
                                            ]}
                                            value={elem?.cabinate_condition}
                                            getIdValue={(val) => {
                                                const data = [...formData?.tvm]
                                                data[ind] = { ...elem, cabinate_condition: val.id }
                                                setData({ ...formData, tvm: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <ConstantInput
                                            label='Recommendation'
                                            value={elem?.cabinate_condition_recommend}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.tvm]
                                                data[ind] = { ...elem, cabinate_condition_recommend: value }
                                                setData({ ...formData, tvm: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <DropDownInput
                                            label='Feasibility of installing power controller inside the cabinet'
                                            data={[
                                                { id: 'Yes', name: "Yes" },
                                                { id: 'No', name: "No" }
                                            ]}
                                            value={elem?.power_control_install}
                                            getIdValue={(val) => {
                                                const data = [...formData?.tvm]
                                                data[ind] = { ...elem, power_control_install: val.id }
                                                setData({ ...formData, tvm: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <ConstantInput
                                            label='Recommendation'
                                            value={elem?.power_control_install_recommend}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.tvm]
                                                data[ind] = { ...elem, power_control_install_recommend: value }
                                                setData({ ...formData, tvm: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    {viewInspectionForms?.status != 4 &&
                                        <div className="col-md-6 col-sm-12">
                                            <FileUpload
                                                id={"tvm"}
                                                multiple
                                                accept=".pdf,.png,.jpg,.jpeg,.doc,.mp4,.xlsx,.xls"
                                                documentUploadUrl={documentUploadUrlPublic}
                                                onChange={(val) => {
                                                    const data = [...formData?.tvm]
                                                    data[ind] = { ...elem, file_path: val }
                                                    setData({ ...formData, tvm: data })
                                                }}
                                            >
                                                <span className="btn btn-transparent">
                                                    Attach Files
                                                </span>
                                            </FileUpload>
                                        </div>
                                    }
                                    {viewInspectionForms?.tvm?.file_path && viewInspectionForms?.tvm?.file_path.map((val) => {
                                        return (
                                            <>

                                                {val !== "" && val !== null && (
                                                    <div className="col-md-4">
                                                        <DocumentView
                                                            title={localization.attachment}
                                                            attachment={val}
                                                        />
                                                    </div>
                                                )}
                                            </>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    )
                })}

                {formData?.led.map((elem, ind) => {
                    return (
                        <div className="panel-card card-details">
                            <div className="panel-heading d-flex flex-row justify-content-between">
                                <div>LED {ind + 1}</div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                        className="bi bi-plus-circle mr-3" style={{ cursor: "pointer" }} viewBox="0 0 16 16" onClick={() => add("led")}>
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                        className="bi bi-dash-circle" style={{ cursor: "pointer" }} viewBox="0 0 16 16" onClick={() => del("led", ind)}>
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                                    </svg>
                                </div>
                            </div>
                            <div className="panel-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Make'
                                            value={elem?.model}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.led]
                                                data[ind] = { ...elem, model: value }
                                                setData({ ...formData, led: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Origin of Make'
                                            value={elem?.model_origin}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.led]
                                                data[ind] = { ...elem, model_origin: value }
                                                setData({ ...formData, led: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <DatePicker
                                            label='Year of Manufacturing'
                                            required={true}
                                            value={elem?.year_of_manufacture}
                                            handleChange={(value) => {
                                                const data = [...formData?.led]
                                                data[ind] = { ...elem, year_of_manufacture: value }
                                                setData({ ...formData, led: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <DatePicker
                                            label='Date of purchase as per PO'
                                            required={true}
                                            value={elem?.date_of_purchase}
                                            handleChange={(value) => {
                                                const data = [...formData?.led]
                                                data[ind] = { ...elem, date_of_purchase: value }
                                                setData({ ...formData, led: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <ConstantInput
                                            label='Spare Availability'
                                            value={elem?.spare_available}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.led]
                                                data[ind] = { ...elem, spare_available: value }
                                                setData({ ...formData, led: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <DropDownInput
                                            label='AMC Scope'
                                            data={[
                                                { id: 'Comprehensive', name: "Comprehensive" },
                                                { id: 'Non-Comprehensive', name: "Non-Comprehensive" },
                                                { id: 'No AMC Scope', name: "No AMC Scope" },
                                            ]}
                                            value={elem?.amc_scope}
                                            getIdValue={(val) => {
                                                const data = [...formData?.led]
                                                data[ind] = { ...elem, amc_scope: val.id }
                                                setData({ ...formData, led: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Reason for AMC Scope'
                                            value={elem?.amc_scope_reason}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.led]
                                                data[ind] = { ...elem, amc_scope_reason: value }
                                                setData({ ...formData, led: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Remaining life of hardware'
                                            value={elem?.lcm_ocm}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.led]
                                                data[ind] = { ...elem, lcm_ocm: value }
                                                setData({ ...formData, led: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Recommendation on Life Expectancy'
                                            value={elem?.recommend_lcm}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.led]
                                                data[ind] = { ...elem, recommend_lcm: value }
                                                setData({ ...formData, led: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <TextAreaInput
                                            inputValue={elem?.feedback_recommend_tech_team}
                                            rows={2}
                                            type="text"
                                            label='Feedback and recommendation from tech team'
                                            handleChange={(e) => {
                                                const data = [...formData?.led]
                                                data[ind] = { ...elem, feedback_recommend_tech_team: e.target.value }
                                                setData({ ...formData, led: data })
                                            }}
                                            errorMsg='Additional Remarks required'
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    {viewInspectionForms?.status != 4 &&
                                        <div className="col-md-6 col-sm-12">
                                            <FileUpload
                                                id={"led"}
                                                multiple
                                                accept=".pdf,.png,.jpg,.jpeg,.doc,.mp4,.xlsx,.xls"
                                                documentUploadUrl={documentUploadUrlPublic}
                                                onChange={(val) => {
                                                    const data = [...formData?.led]
                                                    data[ind] = { ...elem, file_path: val }
                                                    setData({ ...formData, led: data })
                                                }}
                                            >
                                                <span className="btn btn-transparent">
                                                    Attach Files
                                                </span>
                                            </FileUpload>
                                        </div>
                                    }
                                    {viewInspectionForms?.led?.file_path && viewInspectionForms?.led?.file_path.map((val) => {
                                        return (
                                            <>

                                                {val !== "" && val !== null && (
                                                    <div className="col-md-4">
                                                        <DocumentView
                                                            title={localization.attachment}
                                                            attachment={val}
                                                        />
                                                    </div>
                                                )}
                                            </>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    )
                })}

                {formData?.anpr.map((elem, ind) => {
                    return (
                        <div className="panel-card card-details">
                            <div className="panel-heading d-flex flex-row justify-content-between">
                                <div>ANPR {ind + 1}</div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                        className="bi bi-plus-circle mr-3" style={{ cursor: "pointer" }} viewBox="0 0 16 16" onClick={() => add("anpr")}>
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                        className="bi bi-dash-circle" style={{ cursor: "pointer" }} viewBox="0 0 16 16" onClick={() => del("anpr", ind)}>
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                                    </svg>
                                </div>
                            </div>
                            <div className="panel-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Make'
                                            value={elem?.model}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.anpr]
                                                data[ind] = { ...elem, model: value }
                                                setData({ ...formData, anpr: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Origin of Make'
                                            value={elem?.model_origin}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.anpr]
                                                data[ind] = { ...elem, model_origin: value }
                                                setData({ ...formData, anpr: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <DatePicker
                                            label='Year of Manufacturing'
                                            required={true}
                                            value={elem?.year_of_manufacture}
                                            handleChange={(value) => {
                                                const data = [...formData?.anpr]
                                                data[ind] = { ...elem, year_of_manufacture: value }
                                                setData({ ...formData, anpr: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <DatePicker
                                            label='Date of purchase as per PO'
                                            required={true}
                                            value={elem?.date_of_purchase}
                                            handleChange={(value) => {
                                                const data = [...formData?.anpr]
                                                data[ind] = { ...elem, date_of_purchase: value }
                                                setData({ ...formData, anpr: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <ConstantInput
                                            label='Spare Availability'
                                            value={elem?.spare_available}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.anpr]
                                                data[ind] = { ...elem, spare_available: value }
                                                setData({ ...formData, anpr: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <DropDownInput
                                            label='AMC Scope'
                                            data={[
                                                { id: 'Comprehensive', name: "Comprehensive" },
                                                { id: 'Non-Comprehensive', name: "Non-Comprehensive" },
                                                { id: 'No AMC Scope', name: "No AMC Scope" },
                                            ]}
                                            value={elem?.amc_scope}
                                            getIdValue={(val) => {
                                                const data = [...formData?.anpr]
                                                data[ind] = { ...elem, amc_scope: val.id }
                                                setData({ ...formData, anpr: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Reason for AMC Scope'
                                            value={elem?.amc_scope_reason}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.anpr]
                                                data[ind] = { ...elem, amc_scope_reason: value }
                                                setData({ ...formData, anpr: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Remaining life of hardware'
                                            value={elem?.lcm_ocm}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.anpr]
                                                data[ind] = { ...elem, lcm_ocm: value }
                                                setData({ ...formData, anpr: data })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label='Recommendation on Life Expectancy'
                                            value={elem?.recommend_lcm}
                                            type="text"
                                            handleChange={(value) => {
                                                const data = [...formData?.anpr]
                                                data[ind] = { ...elem, recommend_lcm: value }
                                                setData({ ...formData, anpr: data })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <TextAreaInput
                                            inputValue={elem?.feedback_recommend_tech_team}
                                            rows={2}
                                            type="text"
                                            label='Feedback and recommendation from tech team'
                                            handleChange={(e) => {
                                                const data = [...formData?.anpr]
                                                data[ind] = { ...elem, feedback_recommend_tech_team: e.target.value }
                                                setData({ ...formData, anpr: data })
                                            }}
                                            errorMsg='Additional Remarks required'
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    {viewInspectionForms?.status != 4 &&
                                        <div className="col-md-6 col-sm-12">
                                            <FileUpload
                                                id={"anpr"}
                                                multiple
                                                accept=".pdf,.png,.jpg,.jpeg,.doc,.mp4,.xlsx,.xls"
                                                documentUploadUrl={documentUploadUrlPublic}
                                                onChange={(val) => {
                                                    const data = [...formData?.anpr]
                                                    data[ind] = { ...elem, file_path: val }
                                                    setData({ ...formData, anpr: data })

                                                }}
                                            >
                                                <span className="btn btn-transparent">
                                                    Attach Files
                                                </span>
                                            </FileUpload>
                                        </div>
                                    }
                                    {viewInspectionForms?.anpr?.file_path && viewInspectionForms?.anpr?.file_path.map((val) => {
                                        return (
                                            <>

                                                {val !== "" && val !== null && (
                                                    <div className="col-md-4">
                                                        <DocumentView
                                                            title={localization.attachment}
                                                            attachment={val}
                                                        />
                                                    </div>
                                                )}
                                            </>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    )
                })}

                <TextAreaInput
                    inputValue={formData?.remarks}
                    rows={5}
                    type="text"
                    label='Remarks'
                    required
                    isStarRequired={true}
                    handleChange={(e) => setData(formData => ({ ...formData, remarks: e.target.value }))}
                    errorMsg='Additional Remarks required'
                />

            </FormSection>
            <ModalPop
                title={localization.conf}
                show={isModal}
                handleModalHide={() => { setIsModal(false); window.location.reload(); }}
                keyboard
                backdrop>
                <div className="text-center">
                    <div className="success">
                        <img src={Images?.tick} alt="" />
                    </div>
                    <h5>Site Inspection Done Successfully</h5>
                    {roleId.includes(10, 16) && <Link to={`/dashboard/inspection-form-mail/${formData?.request_id}`} className="btn btn-primary mb-4">Send Mail</Link>}
                    {roleId == 9 && <Link to={`/dashboard/inspection-requests`} className="btn btn-primary mb-4">View Inspection Requests</Link>}
                </div>
            </ModalPop>

        </Layout >
    );
};

export default InspectionForm;

